import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const UserGroupIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 576 512" {...props}>
      <path
        fill="currentColor"
        d="M64 128a112 112 0 1 1 224 0a112 112 0 1 1-224 0M0 464c0-97.2 78.8-176 176-176s176 78.8 176 176v6c0 23.2-18.8 42-42 42H42c-23.2 0-42-18.8-42-42zM432 64a96 96 0 1 1 0 192a96 96 0 1 1 0-192m0 240c79.5 0 144 64.5 144 144v22.4c0 23-18.6 41.6-41.6 41.6H389.6c6.6-12.5 10.4-26.8 10.4-42v-6c0-51.5-17.4-98.9-46.5-136.7c22.6-14.7 49.6-23.3 78.5-23.3"
      />
    </svg>
  );
};

export default UserGroupIcon;
